export default __webpack_public_path__ + "static/media/164.044ddc3f.png";